import { MobileCard } from '@/Components/shared/List/MobileCard';
import { ROLE_TYPE_LABELS } from '../types/external-user.types';

interface ExternalUserListItem {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  roleType: string;
  societies?: Array<{ societyId: string; societyName: string; isPrimary: boolean }>;
  isActive: boolean;
  createdAt?: Date | string;
  lastLoginAt?: Date | string;
}

interface ExternalUsersMobileCardsProps {
  data: ExternalUserListItem[];
  onRowClick?: (user: ExternalUserListItem) => void;
}

export function ExternalUsersMobileCards({ data, onRowClick }: ExternalUsersMobileCardsProps) {
  return (
    <div className="tw-space-y-3">
      {data.map((user) => {
        const primarySociety = user.societies?.find(s => s.isPrimary);
        return (
          <MobileCard
            key={user.id}
            title={`${user.firstname} ${user.lastname}`}
            subtitle={primarySociety?.societyName}
            status={
              <div className="tw-flex tw-items-center tw-gap-2">
                <span className="tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-rounded tw-bg-gray-100 tw-text-gray-700">
                  {ROLE_TYPE_LABELS[user.roleType] || user.roleType}
                </span>
                <span className={`tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-rounded ${user.isActive ? 'tw-bg-green-100 tw-text-green-800' : 'tw-bg-red-100 tw-text-red-800'}`}>
                  {user.isActive ? 'Actif' : 'Inactif'}
                </span>
              </div>
            }
            fields={[
              { label: 'Email', value: user.email, fullWidth: true },
              { label: 'Téléphone', value: user.phone || '-' },
              { label: 'Dernière connexion', value: user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleDateString('fr-FR') : '-' },
            ]}
            onClick={onRowClick ? () => onRowClick(user) : undefined}
          />
        );
      })}
    </div>
  );
}
